const todayStore = {
  state: {
    racingEvents: []
  },
  mutations: {
    UPDATE_RACING_EVENTS_DATA(state, payload) {
      state.racingEvents = payload;
    }
  },
};

export default todayStore;
